(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sticky-tabs"] && !Shopify.designMode) return;
  try {
    

(function () {

  /* ========================================
     获取 TAB
  ======================================== */

  function getRoots() {

    return Array.from(
      document.querySelectorAll(
        '[data-product-sticky-tabs]'
      )
    );

  }


  function getTabs(root) {

    return Array.from(
      root.querySelectorAll(
        '[data-product-tab-target]'
      )
    );

  }


  function getTarget(tab) {

    const id =
      tab.getAttribute(
        'data-product-tab-target'
      );


    if (!id) {
      return null;
    }


    return document.getElementById(id);

  }


  /* ========================================
     设置当前 TAB
  ======================================== */

  function setActive(
    root,
    activeTab
  ) {

    const tabs =
      getTabs(root);


    tabs.forEach(function (tab) {

      const active =
        tab === activeTab;


      tab.classList.toggle(
        'is-active',
        active
      );


      tab.setAttribute(
        'aria-selected',
        active ? 'true' : 'false'
      );

    });

  }


  /* ========================================
     点击 TAB
  ======================================== */

  document.addEventListener(
    'pointerup',

    function (event) {

      const tab =
        event.target.closest(
          '[data-product-sticky-tabs] [data-product-tab-target]'
        );


      if (!tab) {
        return;
      }


      const root =
        tab.closest(
          '[data-product-sticky-tabs]'
        );


      if (!root) {
        return;
      }


      const target =
        getTarget(tab);


      if (!target) {

        console.warn(
          '[Avepower TAB] 找不到锚点:',
          tab.getAttribute(
            'data-product-tab-target'
          )
        );

        return;
      }


      event.preventDefault();
      event.stopPropagation();


      setActive(
        root,
        tab
      );


      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

    },

    true
  );


  /* ========================================
     滚动自动切换 TAB
  ======================================== */

  function updateActiveTab(root) {

    const tabs =
      getTabs(root);


    if (!tabs.length) {
      return;
    }


    /*
     * 页面上方 38% 作为 TAB 切换判断线
     */

    const trigger =
      window.innerHeight * 0.38;


    let activeTab =
      tabs[0];


    tabs.forEach(function (tab) {

      const target =
        getTarget(tab);


      if (!target) {
        return;
      }


      const top =
        target
          .getBoundingClientRect()
          .top;


      if (top <= trigger) {

        activeTab =
          tab;

      }

    });


    setActive(
      root,
      activeTab
    );

  }


  /* ========================================
     判断两个区域是否重叠
  ======================================== */

  function rectsOverlap(
    rectA,
    rectB
  ) {

    return (
      rectA.left < rectB.right &&
      rectA.right > rectB.left &&
      rectA.top < rectB.bottom &&
      rectA.bottom > rectB.top
    );

  }


  /* ========================================
     判断 Header 是否真的覆盖 TAB
  ======================================== */

  function isHeaderCoveringTab(root) {

    /*
     * 手机端没有桌面超级菜单，
     * 不执行此逻辑
     */

    if (window.innerWidth < 750) {
      return false;
    }


    const headerGroup =
      document.querySelector(
        '#header-group'
      );


    if (!headerGroup) {
      return false;
    }


    const tabRect =
      root.getBoundingClientRect();


    /*
     * TAB 不在当前可视区域时
     * 不需要进行覆盖判断
     */

    if (
      tabRect.bottom <= 0 ||
      tabRect.top >= window.innerHeight
    ) {
      return false;
    }


    /*
     * 在 TAB 区域取多个检测点
     *
     * 不依赖 Horizon
     * Mega Menu 的具体 class。
     *
     * 只要 Header 内任意真正显示的元素
     * 出现在 TAB 所占区域，
     * 就说明两者实际发生重叠。
     */

    const xPoints = [
      tabRect.left + tabRect.width * 0.10,
      tabRect.left + tabRect.width * 0.25,
      tabRect.left + tabRect.width * 0.50,
      tabRect.left + tabRect.width * 0.75,
      tabRect.left + tabRect.width * 0.90
    ];


    const yPoints = [
      tabRect.top + 5,
      tabRect.top + tabRect.height * 0.50,
      tabRect.bottom - 5
    ];


    for (
      let yIndex = 0;
      yIndex < yPoints.length;
      yIndex++
    ) {

      for (
        let xIndex = 0;
        xIndex < xPoints.length;
        xIndex++
      ) {

        const x =
          Math.max(
            1,
            Math.min(
              window.innerWidth - 1,
              xPoints[xIndex]
            )
          );


        const y =
          Math.max(
            1,
            Math.min(
              window.innerHeight - 1,
              yPoints[yIndex]
            )
          );


        const elements =
          document.elementsFromPoint(
            x,
            y
          );


        for (
          let i = 0;
          i < elements.length;
          i++
        ) {

          const element =
            elements[i];


          /*
           * TAB 自己不算重叠
           */

          if (
            element === root ||
            root.contains(element)
          ) {
            continue;
          }


          /*
           * 只判断 Header / Mega Menu 内元素
           */

          if (
            !headerGroup.contains(element)
          ) {
            continue;
          }


          /*
           * header-group 外壳本身忽略
           */

          if (
            element === headerGroup
          ) {
            continue;
          }


          const style =
            window.getComputedStyle(
              element
            );


          if (
            style.display === 'none' ||
            style.visibility === 'hidden'
          ) {
            continue;
          }


          const opacity =
            parseFloat(
              style.opacity
            );


          if (
            !Number.isNaN(opacity) &&
            opacity === 0
          ) {
            continue;
          }


          const elementRect =
            element.getBoundingClientRect();


          /*
           * 太小的元素忽略
           */

          if (
            elementRect.width < 20 ||
            elementRect.height < 10
          ) {
            continue;
          }


          /*
           * 最后再次确认几何位置
           * 真的与 TAB 重叠
           */

          if (
            rectsOverlap(
              tabRect,
              elementRect
            )
          ) {

            return true;

          }

        }

      }

    }


    return false;

  }


  /* ========================================
     更新 Mega Menu 与 TAB 重叠状态
  ======================================== */

  function updateMegaMenuOverlap() {

    getRoots().forEach(
      function (root) {

        const section =
          root.closest(
            '.shopify-section'
          );


        if (!section) {
          return;
        }


        const covered =
          isHeaderCoveringTab(root);


        section.classList.toggle(
          'is-tab-covered-by-mega-menu',
          covered
        );

      }
    );

  }


  /* ========================================
     更新全部
  ======================================== */

  function updateAll() {

    getRoots().forEach(
      function (root) {

        updateActiveTab(root);

      }
    );


    updateMegaMenuOverlap();

  }


  /* ========================================
     requestAnimationFrame
  ======================================== */

  let ticking = false;


  function requestUpdate() {

    if (ticking) {
      return;
    }


    ticking = true;


    window.requestAnimationFrame(
      function () {

        updateAll();

        ticking = false;

      }
    );

  }


  /* ========================================
     捕获页面内部滚动
  ======================================== */

  document.addEventListener(
    'scroll',
    requestUpdate,
    {
      passive: true,
      capture: true
    }
  );


  window.addEventListener(
    'scroll',
    requestUpdate,
    {
      passive: true
    }
  );


  /* ========================================
     鼠标经过 Header / Mega Menu
  ======================================== */

  document.addEventListener(
    'pointerover',

    function () {

      requestUpdate();


      /*
       * Mega Menu 可能有展开动画，
       * 所以再检查几次。
       */

      window.setTimeout(
        updateMegaMenuOverlap,
        50
      );


      window.setTimeout(
        updateMegaMenuOverlap,
        150
      );


      window.setTimeout(
        updateMegaMenuOverlap,
        300
      );

    },

    true
  );


  document.addEventListener(
    'pointerout',

    function () {

      requestUpdate();


      window.setTimeout(
        updateMegaMenuOverlap,
        50
      );


      window.setTimeout(
        updateMegaMenuOverlap,
        200
      );

    },

    true
  );


  /* ========================================
     Mega Menu 动画结束
  ======================================== */

  document.addEventListener(
    'transitionend',

    function (event) {

      const header =
        document.querySelector(
          '#header-group'
        );


      if (
        header &&
        header.contains(
          event.target
        )
      ) {

        requestUpdate();

      }

    },

    true
  );


  /* ========================================
     窗口大小变化
  ======================================== */

  window.addEventListener(
    'resize',
    requestUpdate,
    {
      passive: true
    }
  );


  /* ========================================
     监听 Horizon Header 状态变化
  ======================================== */

  function setupHeaderObserver() {

    const header =
      document.querySelector(
        '#header-group'
      );


    if (!header) {
      return;
    }


    const observer =
      new MutationObserver(
        function () {

          requestUpdate();


          window.setTimeout(
            updateMegaMenuOverlap,
            100
          );


          window.setTimeout(
            updateMegaMenuOverlap,
            250
          );

        }
      );


    observer.observe(
      header,
      {
        subtree: true,
        childList: true,
        attributes: true,

        attributeFilter: [
          'class',
          'style',
          'open',
          'hidden',
          'aria-expanded'
        ]
      }
    );

  }


  /* ========================================
     Shopify Theme Editor
  ======================================== */

  document.addEventListener(
    'shopify:section:load',
    requestUpdate
  );


  document.addEventListener(
    'shopify:section:reorder',
    requestUpdate
  );


  document.addEventListener(
    'shopify:block:select',
    requestUpdate
  );


  /* ========================================
     初始化
  ======================================== */

  function initProductTabs() {

    setupHeaderObserver();


    updateAll();


    window.setTimeout(
      updateAll,
      300
    );


    window.setTimeout(
      updateAll,
      800
    );


    window.setTimeout(
      updateAll,
      1500
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initProductTabs
    );

  } else {

    initProductTabs();

  }

})();


  } catch(e) { console.error(e); }
})();
})();
